/* Equaliv V2 · cliente do carrinho (gaveta + página) — carregado por sections/eq-cart-drawer.liquid */
(() => {
  if (window.__eqCart2) return;
  window.__eqCart2 = true;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const S = () => window.EQ_SETTINGS || {};
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const drawer = () => document.getElementById('EqCartDrawer');
  const T = (k, fb) => { const d = drawer(); return (d && d.dataset[k]) || fb; };

  const sectionIds = () => {
    const ids = ['eq-cart-drawer'];
    $$('[data-eq-cart-section]').forEach((el) => ids.push(el.dataset.eqCartSection));
    return [...new Set(ids)];
  };
  const busy = (on, msg) => {
    $$('.eq-cd, [data-eq-cart-page]').forEach((el) => { el.classList.toggle('is-busy', on); el.setAttribute('aria-busy', on ? 'true' : 'false'); });
    const st = document.querySelector('[data-eq-cart-status]');
    if (st) st.textContent = on ? (msg || 'Atualizando o carrinho…') : '';
  };
  const showError = (text) => {
    const box = document.querySelector('[data-eq-cart-msg]');
    const d = drawer();
    if (box && d && d.classList.contains('is-open')) { box.hidden = false; box.textContent = text; return; }
    if (window.EQ) EQ.toast(text);
  };
  /* foco: lembra o elemento e devolve-o depois do re-render */
  const snapFocus = () => {
    const a = document.activeElement;
    if (!a || a === document.body) return null;
    const line = a.closest('[data-eq-cl]');
    const attrs = ['data-eq-cl-qty', 'data-eq-cl-input', 'data-eq-cl-remove', 'data-eq-cl-variant', 'data-eq-cl-plan', 'data-eq-coupon-open', 'data-eq-ship-open'];
    const at = attrs.find((x) => a.hasAttribute(x));
    return { key: line && line.dataset.key, at, val: at ? a.getAttribute(at) : null, inDrawer: !!a.closest('#EqCartDrawer') };
  };
  const restoreFocus = (f) => {
    if (!f) return;
    let el = null;
    if (f.key && f.at) {
      const scope = f.inDrawer ? drawer() : document.querySelector('[data-eq-cart-page]');
      const line = scope && scope.querySelector(`[data-eq-cl][data-key="${CSS.escape(f.key)}"]`);
      if (line) el = line.querySelector(f.val !== null && f.val !== '' ? `[${f.at}="${CSS.escape(f.val)}"]` : `[${f.at}]`) || line.querySelector('[data-eq-cl-input]');
    }
    if (!el && f.inDrawer) el = document.getElementById('EqCartTitle');
    if (el) el.focus({ preventScroll: true });
  };
  let selfUpdate = false;
  const apply = async (data) => {
    const sc = document.querySelector('[data-eq-cd-scroll]');
    const top = sc ? sc.scrollTop : 0;
    const f = snapFocus();
    selfUpdate = true;
    await EQ.cart.refresh(data.sections, data && data.items ? data : null);
    selfUpdate = false;
    const sc2 = document.querySelector('[data-eq-cd-scroll]');
    if (sc2) sc2.scrollTop = top;
    restoreFocus(f);
    initDrawerUi();
  };
  const post = async (path, body) => {
    /* assinatura: a linha não leva selling plan da Shopify; o plano vai em _vindi_selling_plan + Plano (adição e
       troca de plano na linha) */
    if (window.EQ && EQ.withPlanProps && path === 'cart/add.js' && body && body.items) body = { ...body, items: EQ.withPlanProps(body.items) };
    if (window.EQ && EQ.planProps && path === 'cart/change.js' && body && 'selling_plan' in body) {
      const cur = await fetch(root + 'cart.js').then((x) => x.json()).catch(() => ({}));
      const it = (cur.items || []).find((i) => i.key === body.id);
      const { selling_plan: planId, ...rest } = body;
      body = { ...rest, properties: EQ.planProps(it && it.properties, planId) };
    }
    const res = await fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: sectionIds().join(','), sections_url: location.pathname }),
    });
    let data = {};
    try { data = await res.json(); } catch (_) {}
    if (!res.ok) {
      const e = new Error(data.description || data.message || S().cartErrorText || 'Não foi possível atualizar o carrinho.');
      e.status = res.status;
      throw e;
    }
    return data;
  };
  let pending = 0;
  const run = async (fn, line) => {
    pending++;
    busy(true);
    if (line) line.classList.add('is-loading');
    const box = document.querySelector('[data-eq-cart-msg]');
    if (box) box.hidden = true;
    try { await fn(); }
    catch (e) {
      if (line && document.contains(line)) {
        const err = line.querySelector('[data-eq-cl-err]');
        const inp = line.querySelector('[data-eq-cl-input]');
        if (inp) inp.value = line.dataset.qty;
        if (err) { err.hidden = false; err.textContent = e.message; }
      } else showError(e.message);
    } finally {
      pending--;
      if (!pending) busy(false);
      if (line && document.contains(line)) line.classList.remove('is-loading');
    }
  };
  const changeLine = (line, quantity, extra = {}) =>
    run(async () => {
      /* assinatura → compra única: a Shopify não apaga propriedades com {}; refaz a linha sem as do plano */
      if ('selling_plan' in extra && !extra.selling_plan && window.EQ && EQ.planProps) {
        const cur = await fetch(root + 'cart.js').then((x) => x.json()).catch(() => ({}));
        const it = (cur.items || []).find((i) => i.key === line.dataset.key);
        const p = (it && it.properties) || {};
        if (it && (EQ.PLAN_ID_KEY in p || EQ.PLAN_LABEL_KEY in p)) {
          await post('cart/change.js', { id: it.key, quantity: 0 });
          await post('cart/add.js', { items: [{ id: it.variant_id, quantity: it.quantity, properties: EQ.planProps(p, null) }] });
          await apply(await post('cart/update.js', {}));
          return;
        }
      }
      let d = await post('cart/change.js', { id: line.dataset.key, quantity, ...extra });
      if ('selling_plan' in extra && window.EQ && EQ.fixPlanProps && (d.items || []).some(EQ.needsPlanLabel)) {
        await EQ.fixPlanProps(d.items);
        d = await post('cart/update.js', {});
      }
      await apply(d);
    }, line);

  /* ---------- cliques ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target;
    const q = t.closest('[data-eq-cl-qty]');
    if (q) {
      const line = q.closest('[data-eq-cl]');
      if (!line || line.classList.contains('is-loading')) return;
      const inp = line.querySelector('[data-eq-cl-input]');
      const max = inp.max ? Number(inp.max) : Infinity;
      const next = Math.min(max, Math.max(0, Number(inp.value || 0) + Number(q.dataset.eqClQty)));
      inp.value = next;
      changeLine(line, next);
      return;
    }
    const rm = t.closest('[data-eq-cl-remove]');
    if (rm) { const line = rm.closest('[data-eq-cl]'); if (line) changeLine(line, 0); return; }
    const kr = t.closest('[data-eq-kit-remove]');
    if (kr) {
      const updates = {};
      kr.dataset.eqKitRemove.split(',').filter(Boolean).forEach((k) => (updates[k] = 0));
      run(async () => { const d = await post('cart/update.js', { updates }); await apply(d); });
      return;
    }
    const pl = t.closest('[data-eq-cl-plan]');
    if (pl) {
      if (pl.getAttribute('aria-checked') === 'true') return;
      const line = pl.closest('[data-eq-cl]');
      const plan = pl.dataset.eqClPlan;
      changeLine(line, Number(line.dataset.qty), { selling_plan: plan ? Number(plan) : null });
      return;
    }
    const ed = t.closest('[data-eq-cl-toggle-edit]');
    if (ed) {
      const line = ed.closest('[data-eq-cl]');
      const on = !line.classList.contains('is-editing');
      line.classList.toggle('is-editing', on);
      ed.setAttribute('aria-expanded', on);
      return;
    }
    const co = t.closest('[data-eq-coupon-open]');
    if (co) {
      const box = co.closest('[data-eq-coupon]');
      const f = box.querySelector('[data-eq-coupon-form]');
      f.hidden = !f.hidden;
      co.setAttribute('aria-expanded', !f.hidden);
      if (!f.hidden) f.querySelector('input').focus();
      return;
    }
    const cr = t.closest('[data-eq-coupon-remove]');
    if (cr) {
      run(async () => {
        const cur = await fetch(root + 'cart.js').then((x) => x.json());
        const codes = (cur.discount_codes || []).map((d) => d.code).filter((c) => c.toLowerCase() !== cr.dataset.eqCouponRemove.toLowerCase());
        const d = await post('cart/update.js', { discount: codes.join(',') });
        await apply(d);
      });
      return;
    }
    const so = t.closest('[data-eq-ship-open]');
    if (so) {
      const box = so.closest('[data-eq-shipcalc]');
      const f = box.querySelector('[data-eq-ship-form]');
      f.hidden = !f.hidden;
      so.setAttribute('aria-expanded', !f.hidden);
      if (!f.hidden) f.querySelector('input').focus();
      return;
    }
    const st = t.closest('[data-eq-cd-sumtoggle]');
    if (st) {
      const sum = st.closest('[data-eq-cd-sum]');
      const on = !sum.classList.contains('is-expanded');
      sum.classList.toggle('is-expanded', on);
      st.setAttribute('aria-expanded', on);
    }
  });

  /* adicionar a partir da página do carrinho: atualiza a página sem abrir a gaveta */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-eq-add]');
    if (!btn || !btn.closest('[data-eq-cart-page]')) return;
    if (btn.dataset.quickHandle && !btn.dataset.single) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    let items = null;
    try { items = btn.dataset.eqItems ? JSON.parse(btn.dataset.eqItems) : null; } catch (_) {}
    if (!items) items = [{ id: Number(btn.dataset.variantId), quantity: Number(btn.dataset.quantity || 1) }];
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    run(async () => {
      const added = await post('cart/add.js', { items });
      const cart = await fetch(root + 'cart.js').then((r) => r.json());
      await apply({ ...cart, sections: added.sections });
      EQ.toast(S().addedText || 'Produto adicionado à sacola');
    }).finally(() => { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); });
  }, true);

  /* quantidade digitada, troca de variante */
  document.addEventListener('change', (e) => {
    const inp = e.target.closest('[data-eq-cl-input]');
    if (inp) {
      const line = inp.closest('[data-eq-cl]');
      const max = inp.max ? Number(inp.max) : Infinity;
      const v = Math.min(max, Math.max(0, parseInt(inp.value, 10) || 0));
      if (String(v) === line.dataset.qty) { inp.value = v; return; }
      changeLine(line, v);
      return;
    }
    const sel = e.target.closest('[data-eq-cl-variant]');
    if (sel) {
      const line = sel.closest('[data-eq-cl]');
      run(async () => {
        const cur = await fetch(root + 'cart.js').then((x) => x.json());
        const it = (cur.items || []).find((i) => i.key === line.dataset.key);
        if (!it) return;
        const item = { id: Number(sel.value), quantity: it.quantity, properties: it.properties || {} }; // o plano segue nas propriedades
        await post('cart/change.js', { id: it.key, quantity: 0 });
        try {
          await post('cart/add.js', { items: [item] });
        } catch (err) {
          await post('cart/add.js', { items: [{ id: it.variant_id, quantity: it.quantity, properties: it.properties || {} }] });
          throw err;
        }
        const cart = await post('cart/update.js', {});
        await apply(cart);
      }, line);
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-eq-cl-input]')) { e.preventDefault(); e.target.blur(); }
  });

  /* cupom e frete */
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-eq-coupon-form]');
    if (f) {
      e.preventDefault();
      const code = f.querySelector('input').value.trim();
      const msg = f.parentElement.querySelector('[data-eq-coupon-msg]');
      if (!code) { msg.hidden = false; msg.textContent = T('couponEmpty', 'Digite um código.'); return; }
      run(async () => {
        const cur = await fetch(root + 'cart.js').then((x) => x.json());
        const codes = (cur.discount_codes || []).map((d) => d.code);
        if (!codes.some((c) => c.toLowerCase() === code.toLowerCase())) codes.push(code);
        const d = await post('cart/update.js', { discount: codes.join(',') });
        const ok = (d.discount_codes || []).find((x) => x.code.toLowerCase() === code.toLowerCase());
        if (!ok || !ok.applicable) {
          const clean = codes.filter((c) => c.toLowerCase() !== code.toLowerCase());
          const d2 = await post('cart/update.js', { discount: clean.join(',') });
          await apply(d2);
          const m2 = document.querySelectorAll('[data-eq-coupon-msg]');
          const box = [...document.querySelectorAll('[data-eq-coupon]')].find((b) => b.dataset.kind === f.closest('[data-eq-coupon]').dataset.kind && b.closest('#EqCartDrawer') === f.closest('#EqCartDrawer'));
          const target = box ? box.querySelector('[data-eq-coupon-msg]') : m2[0];
          if (box) { const ff = box.querySelector('[data-eq-coupon-form]'); ff.hidden = false; const det = box.closest('details'); if (det) det.open = true; ff.querySelector('input').value = code; }
          if (target) { target.hidden = false; target.textContent = T('couponInvalid', 'Cupom inválido ou não aplicável a este carrinho.'); }
          return;
        }
        await apply(d);
      });
      return;
    }
    const sf = e.target.closest('[data-eq-ship-form]');
    if (sf) {
      e.preventDefault();
      const zip = sf.querySelector('input').value.replace(/\D/g, '');
      const list = sf.parentElement.querySelector('[data-eq-ship-rates]');
      list.hidden = false;
      if (zip.length !== 8) { list.innerHTML = `<li>${T('zipInvalid', 'Digite um CEP com 8 números.')}</li>`; return; }
      list.innerHTML = `<li>${T('zipLoading', 'Calculando…')}</li>`;
      const q = `shipping_address[zip]=${zip}&shipping_address[country]=BR`;
      (async () => {
        try {
          await fetch(`${root}cart/prepare_shipping_rates.json?${q}`, { method: 'POST' });
          let data = null;
          for (let i = 0; i < 10 && !data; i++) {
            const r = await fetch(`${root}cart/async_shipping_rates.json?${q}`);
            if (r.status === 200) { const j = await r.json(); if (j && j.shipping_rates) data = j; }
            if (!data) await new Promise((ok) => setTimeout(ok, 700));
          }
          const rates = (data && data.shipping_rates) || [];
          const free = T('freeLabel', 'Grátis');
          list.innerHTML = rates.length
            ? rates.map((x) => `<li><span>${x.name}${x.delivery_days && x.delivery_days.length ? ` · ${x.delivery_days[0]}–${x.delivery_days[x.delivery_days.length - 1]} dias úteis` : ''}</span><span>${Number(x.price) === 0 ? free : EQ.money(Math.round(Number(x.price) * 100))}</span></li>`).join('')
            : `<li>${T('zipNone', 'Nenhuma opção de entrega para este CEP.')}</li>`;
        } catch (_) { list.innerHTML = `<li>${T('zipError', 'Não foi possível calcular agora. Tente de novo.')}</li>`; }
      })();
    }
  });
  document.addEventListener('input', (e) => {
    if (!e.target.matches || !e.target.matches('[data-eq-cep]')) return;
    const d = e.target.value.replace(/\D/g, '').slice(0, 8);
    e.target.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
  });

  /* checkout: estado de envio */
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-eq-checkout]');
    if (!f) return;
    const b = f.querySelector('button');
    if (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); }
  });

  /* outras partes do tema mudaram o carrinho: recarrega a página do carrinho */
  document.addEventListener('eq:cart:updated', async () => {
    if (selfUpdate) return;
    const page = document.querySelector('[data-eq-cart-section]');
    if (page) {
      const id = page.dataset.eqCartSection;
      try {
        const json = await fetch(`${location.pathname}?sections=${encodeURIComponent(id)}`).then((r) => r.json());
        selfUpdate = true;
        await EQ.cart.refresh(json);
        selfUpdate = false;
      } catch (_) { selfUpdate = false; }
    }
    initDrawerUi();
  });

  /* ---------- UI da gaveta: contador do upsell, recomendações, foco ---------- */
  const initDrawerUi = () => {
    const up = document.querySelector('[data-eq-cd-upsell]');
    if (up && up.dataset.eqCdReco && !up.dataset.loaded) {
      up.dataset.loaded = '1';
      fetch(up.dataset.eqCdReco).then((r) => r.text()).then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-eq-cd-upsell] [data-eq-track]');
        const cur = document.querySelector('[data-eq-cd-upsell] [data-eq-track]');
        if (fresh && cur && fresh.children.length) {
          cur.innerHTML = fresh.innerHTML;
          const c = document.querySelector('[data-eq-cd-counter]');
          if (c) c.textContent = `1/${fresh.children.length}`;
          document.querySelector('[data-eq-cd-upsell]').hidden = false;
        }
      }).catch(() => {});
    }
    $$('[data-eq-cd-carousel]').forEach((car) => {
      if (car.dataset.cnt) return;
      car.dataset.cnt = '1';
      const tr = car.querySelector('[data-eq-track]');
      const c = car.querySelector('[data-eq-cd-counter]');
      if (!tr || !c) return;
      const paint = () => {
        const n = tr.children.length;
        const w = tr.children[0] ? tr.children[0].getBoundingClientRect().width + 12 : 1;
        const i = Math.min(n, Math.round(tr.scrollLeft / w) + 1);
        c.textContent = `${i}/${n}`;
      };
      tr.addEventListener('scroll', paint, { passive: true });
      paint();
    });
  };

  let opener = null;
  document.addEventListener('click', (e) => { const o = e.target.closest('[data-eq-open="EqCartDrawer"]'); if (o) opener = o; }, true);
  document.addEventListener('eq:cart:open', () => { if (!opener) opener = document.activeElement; });
  const watch = () => {
    const d = drawer();
    if (!d || d.dataset.watch) return;
    d.dataset.watch = '1';
    new MutationObserver(() => {
      const open = d.classList.contains('is-open');
      if (open) { initDrawerUi(); const t = document.getElementById('EqCartTitle'); if (t && !d.contains(document.activeElement)) setTimeout(() => t.focus({ preventScroll: true }), 80); }
      else if (opener && document.contains(opener)) { opener.focus({ preventScroll: true }); opener = null; }
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
    /* foco preso na gaveta aberta */
    d.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab' || !d.classList.contains('is-open')) return;
      const f = $$('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])', d).filter((x) => x.offsetParent !== null && !x.closest('[hidden]'));
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  };
  const boot = () => { watch(); initDrawerUi(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
